import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { RecSearchService, Name } from '../../rec-search-service';
//import { Observable } from 'rxjs/Observable';
import { Utility } from './../../../shared/viewmodels/UtilityObj';
//import { AppState } from './../../../app.state';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
import { RecNameSearchGridComponent } from '../../components/rec-name-search-grid/rec-name-search-grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import * as NameActions from './../../../store/actions/name.action';
import * as CompoundNameActions from './../../../store/actions/compoundname.action'
import * as RoleActions from './../../../store/actions/role.action';
import * as ContainsActions from './../../../store/actions/contains.action';
import * as DateRangeActions from './../../../store/actions/daterange.action';
import * as CityActions from './../../../store/actions/citytown.action';
import * as DocTypeActions from './../../../store/actions/doctype.action';
import { DatePipe } from '@angular/common';
import { ShoppingBasketService } from '../../../shared/services/shopping-basket.service'

@Component({
  selector: 'app-rec-name-result-pg',
  providers: [DatePipe],
  templateUrl: './rec-name-result-pg.component.html',
  styleUrls: ['./rec-name-result-pg.component.css']
})
export class RecNameResultPgComponent implements OnInit {

  @ViewChild(RecNameSearchGridComponent, { static: true }) recNameResults;
  lname: string;
  fname: string;
  role: string;
  isNewTab: boolean;
  today: Date;
  dummyVar: string[];

  constructor(public nav: NavMenuService, public router: ActivatedRoute, private store: Store<AppState>, private datepipe: DatePipe, private sbService: ShoppingBasketService) {
    //console.log('rec name result page');
    console.log("rec name search result constr")
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.sbService.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.sbService.updateBasketCount(0);

    var t = window.location.href;

    this.lname = this.router.snapshot.paramMap.get('lname');
    this.fname = this.router.snapshot.paramMap.get('fname');
    this.role = this.router.snapshot.paramMap.get('role');

  }



  ngOnInit() {

    if (this.lname > '')
      this.isNewTab = true;
    else
      this.isNewTab = false;


    //// hide the navigation menu.
    this.nav.hide();

    if (this.isNewTab) {

      this.today = new Date();

      this.delRecFromStore(0);

      this.addRecToStore(
        this.fname,
        this.lname,
        this.role,
        0, //contains,
        '', //fName2,
        '', //lName2,
        0, //roleID2,
        '1/1/1962', //fromDate,
        this.datepipe.transform(this.today, 'MM-dd-yyyy'),  //this.dateRangeChild.utilityobj.toDate,
        this.dummyVar, //citytowns,
        this.dummyVar); //doctypes);
    }

  }
  
  delRecFromStore(index) {
    //this.store.dispatch(new RecActions.RemoveRec(index));
    this.store.dispatch(new NameActions.RemoveName(index));
    this.store.dispatch(new RoleActions.RemoveRole(index));
    this.store.dispatch(new ContainsActions.RemoveContains(index));
    this.store.dispatch(new DateRangeActions.RemoveDate(index));
    this.store.dispatch(new CityActions.RemoveCity(index));
    this.store.dispatch(new DocTypeActions.RemoveDoct(index));
  }

  addRecToStore(fname, lname, role, Contains, fname2, lname2, role2, fromdate, todate, citytowns, doctypes) {

    this.store.dispatch(new CompoundNameActions.AddName({
      fName: fname,
      lastcorpName: lname
    }));

    this.store.dispatch(new RoleActions.AddRole({
      roleID: role
    }));

    //    console.log('Contains - ' + Contains);

    this.store.dispatch(new ContainsActions.AddContains({
      contains: Contains
    }));

    //    this.store.select('coresearchdata').subscribe(data => this.recs = data);
    //    console.log(this.recs.name[0].lastcorpName);
    //    console.log('contains - ' + this.recs.contains[0].contains);



    this.store.dispatch(new DateRangeActions.AddDate({
      fromDate: fromdate,
      toDate: todate
    }));

    this.store.dispatch(new CityActions.AddCity({
      citytowns: citytowns
    }));

    this.store.dispatch(new DocTypeActions.AddDoct({
      doctypes: doctypes
    }));
  }




}
